export * from './platform_admin_ui'
export * from './random_project_hotkey'
export * from './ga_scroll_tracking'
export * from './subscription_toggle'
export * from './cookie_banner'

import '../shared/translation_setup'
// this file is auto-generated. to update it
// with content from the yml files,
// restart server or run `rake i18n:js:export`
export * from './translations'
